/**
 * Stick a section footer to the top when scrolled while retaining it's bottom: 0;
 * NOTE: Due to the specifics of how the flow-sections work, this needs to have it's own directive.
 *
 * Usage: <div class="flow-section-dark sticky-flow-section">
 */
angular.module('hjApp').directive('stickyFlowSection', [
    '$window',
    function ($window) {
        return {
            restrict: 'C',
            replace: 'false',
            link: function (scope, element) {
                var contentOffset = 0 /* #topbar + #sitebar */,
                    distanceFromTop = 0,
                    jqElem = $(element),
                    marginTop = 0,
                    parentSection = jqElem.parent('.flow-section-content-inner'),
                    parentSectionDistanceFromBottom = 0,
                    scrolledTill = 0,
                    scrolledTillEndOfParent = false,
                    window = angular.element($window),
                    windowHeight;

                function trigger() {
                    // Refresh values on scroll.
                    contentOffset = $('#content-inner').offset() ? $('#content-inner').offset().top : 0;
                    distanceFromTop = parseInt(parentSection.offset().top);
                    windowHeight = Math.max(document.documentElement.clientHeight, $window.innerHeight);
                    parentSectionDistanceFromBottom =
                        parseInt(parentSection.offset().top) + parentSection.outerHeight();
                    scrolledTill = window.scrollTop() + windowHeight;
                    scrolledTillEndOfParent = scrolledTill >= parentSectionDistanceFromBottom;

                    // If window height is lower than 650, don't stick the section.
                    if (windowHeight < 650) {
                        jqElem.css({
                            top: '0px',
                            bottom: '0px'
                        });
                        return;
                    }

                    marginTop = window.scrollTop() - (distanceFromTop - contentOffset);
                    if (marginTop < 0) {
                        marginTop = 0;
                    }

                    if (scrolledTillEndOfParent) {
                        // We scrolled past the parent's bottom-most point.
                        jqElem.css({
                            bottom: '0px'
                        });
                    } else {
                        // We are scrolling through the parent element's height:
                        // 1. Apply a margin top to stick the element to the top.
                        // 2. Set the bottom to a number which will make the "full" element be visible on screen.
                        jqElem.css({
                            top: marginTop + 'px',
                            bottom: parentSectionDistanceFromBottom - scrolledTill + 'px'
                        });
                    }
                }

                window.bind('scroll resize', function () {
                    trigger();
                });
            }
        };
    }
]);
